<template>
  <div id="app">
    <head-Back title="VIP服务"></head-Back>

    <div class="pay-result">
      <div :class="imgclass"></div>
      <p class="pay-result-text">{{desc}}</p>
      <!-- <p class="pay-result-tiao">{{outtime}} s后自动返回</p> -->
      <button @click="toApp">手动跳转</button>
    </div>
  </div>
</template>
<script>
import headBack from "../../../common/head";

import util from "@/utils/util";
import store from "@/store/index";
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import api from "@/api/index";
import tips from "@/estoast";

export default {
  name: "app",
  data() {
    return {
      msg: "支付结果",
      orderId: null,
      desc: "支付成功",
      imgclass: "pay-img",
      outtime: 3
    };
  },
  mounted: function() {
    var orderId = this.$route.params.orderid;
    this.orderId = orderId;
    console.log("订单id:" + orderId);
    this.queryOrder();
  },
  methods: {
    toApp() {
       var paydues = localStorage.getItem("paydues_"+this.getUserInfo.id);
      console.log("续费标识"+paydues)
      // alert(paydues)
      if(paydues == '2'){
        localStorage.removeItem("paydues_"+this.getUserInfo.id)
        window.location.href = "hqml://main";
      }else{
        window.location.href = "hqml://closeWindow";
      }
    },
    timer(wait) {
      let _this = this;

      if (wait == 0) {
        //this.toApp();
      } else {
        this.outtime = wait;
        wait--;
        setTimeout(function() {
          _this.timer(wait);
          _this.queryOrder();
        }, 1000);
      }
    },
    queryOrder: function() {
      var data = {
        orderid: this.orderId
      };

      this.$customAjax({
        method: "POST",
        url: api.qml.queryOrderApp,
        data: data
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            console.log(res.result);
            if (res.result.paystate == 1) {
              this.desc = "支付成功";
              this.imgclass = "pay-img-su";
              //this.timer(3);
              localStorage.setItem("paydues_"+this.getUserInfo.id,'2');
            } else if (res.result.paystate == 2) {
              this.desc = "支付失败";
              //this.timer(3);
            } else if (res.result.paystate == 0) {
              this.desc = "未支付完成";
              this.timer(20);
            }
            //调用websock进行页面的刷星
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters(["getWxAlert", "loading", "getUserInfo", "getToken"])
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
  background: rgba(255, 255, 255, 1);
}
.pay-result {
  height: 400px;
  width: 100%;
  margin: 144px 0 0 0;
}
.pay-result-text {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}
.pay-result-tiao {
  height: 44px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  line-height: 44px;
}
.pay-result button {
  width: 632px;
  height: 92px;
  background: linear-gradient(
    180deg,
    rgba(45, 80, 237, 1) 0%,
    rgba(78, 160, 254, 1) 100%
  );
  box-shadow: 0px 4px 12px 4px rgba(202, 222, 255, 1);
  border-radius: 50px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 92px;
  border: none;
}
.pay-img {
  width: 132px;
  height: 132px;
  margin: 74px auto 30px;
  background: url("./img/pay-fail.png");
  background-size: 100% 100%;
}
.pay-img-su {
  width: 132px;
  height: 132px;
  margin: 74px auto 30px;
  background: url("./img/pay-success.png");
  background-size: 100% 100%;
}
.pay-img img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/app/qml/pay/payResult.vue